import React from "react"; 

 const Controlspacing = (props) => {
    return <svg width="128" height="160" viewBox="0 0 128 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="128" height="160" rx="2" fill="#E5F1F9"/>
        
    <rect width="96" height="96" transform="translate(16 32)" fill="white"/>
    <rect x="20.5" y="61.5" width="87" height={props.isHovspacingtop === true || props.isHovspacingbottom === true ? "42" :"38"} fill="#F0F0F0"/>
    <rect x="20.5" y="61.5" width="87" height={props.isHovspacingtop === true || props.isHovspacingbottom === true ? "42" :"38"} stroke="#C4C4C4" stroke-dasharray="2 2"/>
    <rect x="21" y="62" width="9" height="37" fill="#F0F0F0"/>

    <rect x="30" y="71" width="21" height="5" rx="1" fill="#606060" 
    style={{ 
        transform : props.isHovspacingleft === true ? "scaleX(0.97) translate(3px, 0)" :  
            props.isHovspacingtop === true ? " translate(0px, 6px)" : 
            props.isHovspacingbottom === true ? "translate(0, 0)" : "" , 
        transition: "transform 0.3s ease-in-out"
    }}
    />
    <rect x="30" y="78" width="68" height="12" rx="1" fill="#C4C4C4" 
        style={{ 
            transform : props.isHovspacingleft === true ? "scaleX(0.97) translate(3px, 0)" :  
                props.isHovspacingright === true ?  "scaleX(0.97) translate(0px, 0)" : 
                props.isHovspacingtop === true ? "translate(0, 6px)" : 
                props.isHovspacingbottom === true ? " translate(0, 0)" : "" , 
            transition: "transform 0.3s ease-in-out"
        }}
    
    />

        
            <rect width="12" height="38" transform="translate(20 61)" fill="#FEE8D3" 
            style={{ 
                display : props.isHovspacingleft === true ? "" : "none"
            }}/>
        
            <rect width="12" height="38" transform="translate(95 61)" fill="#FEE8D3" 
            style={{ 
                display : props.isHovspacingright === true ? "" : "none"
            }}
            />

            <rect width="85" height="12" transform="translate(22 62)" fill="#FEE8D3" 
            style={{ 
                display : props.isHovspacingtop === true ? "" : "none"
            }}
            />

            <rect width="85" height="14" transform="translate(22 90)" fill="#FEE8D3" 
            style={{ 
                display : props.isHovspacingbottom === true ? "" : "none"
            }}
            />
    </svg>
}
export default Controlspacing;